import { Link } from '@/components'
import { useTranslation } from '@/utils/hook'
import { ComponentProps, Flex } from '@/components/ui'
import styled from 'styled-components'
import { IconChevronRight } from '@tabler/icons-react'
import Image from 'next/image'

interface HeaderProps extends ComponentProps {
  id: string
  name: string
  navLinkColor?: string
}

const HOMEPAGE_URI = process.env.NEXT_PUBLIC_HOMEPAGE_URI

export function TemplateDetailHeader({
  id,
  name,
  style,
  navLinkColor
}: HeaderProps): JSX.Element {
  const t = useTranslation()

  function handleClick() {
    window.location.href = `${HOMEPAGE_URI}/template/${id}`
  }

  return (
    <Sticky>
      <div style={style}>
        <Container className="header-container" align="center">
          <LogoLink href="/" title="HeyForm">
            <Image
              src="/static/logo.svg"
              alt="heyform"
              width={160}
              height={42}
            />
          </LogoLink>

          <NavBar navLinkColor={navLinkColor}>
            <a className="text-slate-900" href="/templates">
              {t('common.templates')}
            </a>
            <IconChevronRight className="w-5 h-5 text-secondary" />
            <span className="text-slate-900 text-lg">{name}</span>
          </NavBar>

          <div className="">
            <button
              className="px-3 py-1 md:px-6 md:py-3 bg-slate-950 text-white rounded-lg font-medium"
              onClick={handleClick}
            >
              Use this template
            </button>
          </div>
        </Container>
      </div>
    </Sticky>
  )
}

const Sticky = styled.div`
  display: block;
  margin: 0 auto;
  top: 0;
  background: #ffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  position: sticky;
  z-index: 999;

  @media only screen and (max-width: 1000px) {
    .navbar {
      display: none;
    }

    .header-container {
      justify-content: space-between;
      width: 100%;
      height: 60px;
      padding: 6px 25px;
      margin: auto;
    }
  }
`

const NavBar = styled.div<{
  navLinkColor?: string
}>`
  display: flex;
  align-items: center;
  flex: 1 auto;
  padding-left: 50px;

  &,
  a {
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    color: ${({ navLinkColor, theme }) => navLinkColor || theme.text};
  }

  svg {
    color: ${({ navLinkColor, theme }) => navLinkColor || theme.lightGray};
    margin-left: 4px;
    margin-right: 4px;
  }

  @media only screen and (max-width: 1000px) {
    display: none;
  }
`

const Container = styled(Flex)`
  width: auto;
  height: 80px;
  margin: 0 50px;

  a {
    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }
`

const LogoLink = styled(Link)`
  @media only screen and (max-width: 1000px) {
    img {
      width: 120px;
      height: auto;
    }
  }
`
